import { useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vs } from "react-syntax-highlighter/dist/esm/styles/prism";
import { LuCopyCheck, LuCopy } from "react-icons/lu";
//import { Check, Copy } from "lucide-react";
const customTheme = {
  ...vs,
  'code[class*="language-"]': {
    ...vs['code[class*="language-"]'],
    //backgroundColor: "#f5f5f5",
  },
  'pre[class*="language-"]': {
    ...vs['pre[class*="language-"]'],
    backgroundColor: "#F6F8FA", // Background for the code block
    color: "#000", // General text color
    borderRadius: "8px",
    padding: "20px",
  },
  keyword: {
    color: "#3d251e", // Customize keyword color (e.g., `true`, `if`, etc.)
  },
  string: {
    color: "#27AE60", // Customize string color (e.g., `"hello"`, `'world'`)
  },
  function: {
    color: "#61dafb", // Customize function name color
  },
  comment: {
    color: "#999999", // Customize comment color
    fontStyle: "italic", // Add italic style for comments
  },
  number: {
    color: "#0077b6", // Customize number color (e.g., `123`, `0.5`)
  },
  property: {
    color: "#000000", // Customize property (keys like `email`, `password`, `domain`)
  },
  boolean: {
    color: "#8b6c5c", // Customize boolean
  },
};
export const CodeBlockWithCopy = ({ children, language }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 4000);
  };

  return (
    <div className="relative mt-4 rounded-lg border border-gray-200 bg-white">
      <div className="flex items-center justify-between border-b border-gray-200 px-4 py-2">
        <span className="text-sm font-medium text-gray-600">
          {language.toUpperCase()}
        </span>
        <button
          onClick={() => copyToClipboard(children)}
          className="flex items-center rounded-md px-2 py-1 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-white border-2  border-[#F6F8FA]"
        >
          {copied ? (
            <>
              <LuCopyCheck className="ml-1 h-4 w-4 text-green-500" /> Copied
            </>
          ) : (
            <>
              <LuCopy className="ml-1 h-4 w-4" /> Copy
            </>
          )}
        </button>
      </div>

      <SyntaxHighlighter
        language={language.toLowerCase()}
        style={customTheme}
        customStyle={{
          margin: 0,
          padding: "1rem",
          background: "#F6F8FA",
          borderTopLeftRadius: "0rem",
          borderTopRightRadius: "0rem",
          borderBottomLeftRadius: "0.5rem",
          borderBottomRightRadius: "0.5rem",
          fontSize: "1em",
        }}
      >
        {children}
      </SyntaxHighlighter>
    </div>
  );
};
